import React, { Fragment } from 'react'

import { useNavbarTheme } from '../contexts/NavbarTheme'
import useInView from '../hooks/useInView'

import { media, rem } from '../styles/tools'

import SEO from '../components/SEO'
import Wrapper from '../components/Wrapper'
import Shell from '../components/Shell'
import Space from '../components/Space'
import Link from '../components/Link'
import BackgroundText from '../components/BackgroundText'
import ChallengeUsFooter from '../components/ChallengeUsFooter'
import { ContentAboveFooter } from '../components/Footer'
import { AutoSlide } from '../components/Animated'
import ShowCells from '../components/ShowCells'
import LogoCell from '../components/LogoCell'
import ScrollToLink from '../components/ScrollToLink'
import HelloFab from '../components/HelloFab'
import VerticalLine from '../components/VerticalLine'
import { Headline, BoldText, WideText } from '../styles/typography'

import _1stdibs from '../assets/logos/1stdibs.svg'
import abcLogo from '../assets/logos/abc-logo.svg'
import acHotelsLogo from '../assets/logos/ac-hotels-logo.svg'
import adonit from '../assets/logos/adonit.svg'
import alisoviejo from '../assets/logos/alisoviejo.svg'
import amc from '../assets/logos/amc.svg'
import azubu from '../assets/logos/azubu.svg'
import bravo from '../assets/logos/bravo.svg'
import burbank from '../assets/logos/burbank.svg'
import butterfingerLogo from '../assets/logos/butterfinger-logo.svg'
import cbsInteractive from '../assets/logos/cbs-interactive.svg'
import coldwellBanker from '../assets/logos/coldwell-banker.svg'
import dignityHealth from '../assets/logos/dignity-health.svg'
import directtvLogo from '../assets/logos/directtv-logo.svg'
import espnLogo from '../assets/logos/espn-logo.svg'
import foxLogo from '../assets/logos/fox-logo.svg'
import gatorade from '../assets/logos/gatorade.svg'
import hamptonInn from '../assets/logos/hampton-inn.svg'
import hotPockets from '../assets/logos/hot-pockets.svg'
import kraftFoodsLogo from '../assets/logos/kraft-foods-logo.svg'
import motiv from '../assets/logos/motiv.svg'
import msnbc from '../assets/logos/msnbc.svg'
import nestea from '../assets/logos/nestea.svg'
import paramount from '../assets/logos/paramount.svg'
import pressBros from '../assets/logos/press-bros.svg'
import presspops from '../assets/logos/presspops.svg'
import princessCruises from '../assets/logos/princess-cruises.svg'
import sapphireVentures from '../assets/logos/sapphire-ventures.svg'
import smokeyBones from '../assets/logos/smokey-bones.svg'
import sothebys from '../assets/logos/sothebys.svg'
import tennisChannel from '../assets/logos/tennis-channel.svg'
import toyotaLogo from '../assets/logos/toyota-logo.svg'
import universal from '../assets/logos/universal.svg'
import voskos from '../assets/logos/voskos.svg'
import wHotel from '../assets/logos/w-hotel.svg'
import westfield from '../assets/logos/westfield.svg'

export default () => {
  useNavbarTheme('dark')
  const [bottomRef, bottomInView] = useInView({ triggerOnce: false })

  return (
    <Fragment>
      <SEO title="Our Clients" />
      <Shell>
        <ContentAboveFooter>
          <Wrapper padded>
            <Space y={100} />
            <BackgroundText css={{ [media.max.tabletMd]: { display: 'none' } }}>
              CLIENTS
            </BackgroundText>
            <AutoSlide
              left
              css={{
                [media.max.tabletMd]: { display: 'none' },
                marginTop: '-6.35vmax',
                marginLeft: rem(-5),
              }}
            >
              <Headline css={{ maxWidth: '13em' }}>
                From disruptive startups to industry titans.
              </Headline>
            </AutoSlide>
            <Space y={{ tabletMd: 32 }} />
            <AutoSlide left delay={120}>
              <BoldText
                css={{
                  [media.max.tabletMd]: { display: 'none' },
                  width: '75%',
                }}
              >
                Our experience includes creative and strategic work for scores
                of clients, served while working with other agencies, startups,
                and Fortune 500 corporations.
              </BoldText>
            </AutoSlide>
            <Space y={64} />
            <ShowCells
              css={{
                display: 'grid',
                '--cols': 2,
                gridTemplateColumns: 'repeat(var(--cols), 1fr)',
                [media.tablet]: { '--cols': 4 },
                gridGap: 10,
                padding: 5,
              }}
            >
              <LogoCell solid>
                <img
                  width="65%"
                  style={{ transform: 'scale(.8)' }}
                  src={_1stdibs}
                  alt="1stdibs logo"
                />
              </LogoCell>
              <LogoCell solid>
                <img
                  width="50%"
                  style={{ transform: 'scale(.8)' }}
                  src={abcLogo}
                  alt="ABC logo"
                />
              </LogoCell>
              <LogoCell solid>
                <img
                  width="46%"
                  style={{ transform: 'scale(.8)' }}
                  src={acHotelsLogo}
                  alt="AC hotels logo"
                />
              </LogoCell>
              <LogoCell solid>
                <img
                  width="65%"
                  style={{ transform: 'translateY(-20px) scale(.8)' }}
                  src={adonit}
                  alt="Adonit logo"
                />
              </LogoCell>
              <LogoCell solid>
                <img
                  width="80%"
                  style={{ transform: 'scale(.8)' }}
                  src={alisoviejo}
                  alt="Aliso Viejo logo"
                />
              </LogoCell>
              <LogoCell solid>
                <img
                  width="60%"
                  style={{ transform: 'scale(.8)' }}
                  src={amc}
                  alt="AMC logo"
                />
              </LogoCell>
              <LogoCell solid>
                <img
                  width="70%"
                  style={{ transform: 'scale(.8)' }}
                  src={azubu}
                  alt="Azubu logo"
                />
              </LogoCell>
              <LogoCell solid>
                <img
                  width="60%"
                  style={{ transform: 'scale(.8)' }}
                  src={bravo}
                  alt="Bravo logo"
                />
              </LogoCell>
              <LogoCell solid>
                <img
                  width="72%"
                  style={{ transform: 'scale(.8)' }}
                  src={burbank}
                  alt="Burbank logo"
                />
              </LogoCell>
              <LogoCell solid>
                <img
                  width="75%"
                  style={{ transform: 'scale(.8)' }}
                  src={butterfingerLogo}
                  alt="Butterfinger logo"
                />
              </LogoCell>
              <LogoCell solid>
                <img
                  width="75%"
                  style={{ transform: 'scale(.8)' }}
                  src={cbsInteractive}
                  alt="CBS Interactive logo"
                />
              </LogoCell>
              <LogoCell solid>
                <img
                  width="72%"
                  style={{ transform: 'scale(.8)' }}
                  src={coldwellBanker}
                  alt="Coldwell Banker logo"
                />
              </LogoCell>
              <LogoCell solid>
                <img
                  width="85%"
                  style={{ transform: 'scale(.8)' }}
                  src={dignityHealth}
                  alt="Dignity Health logo"
                />
              </LogoCell>
              <LogoCell solid>
                <img
                  width="75%"
                  style={{ transform: 'scale(.8)' }}
                  src={directtvLogo}
                  alt="Directtv logo"
                />
              </LogoCell>
              <LogoCell solid>
                <img
                  width="60%"
                  style={{ transform: 'scale(.8)' }}
                  src={espnLogo}
                  alt="ESPN logo"
                />
              </LogoCell>
              <LogoCell solid>
                <img
                  width="50%"
                  style={{ transform: 'scale(.8)' }}
                  src={foxLogo}
                  alt="Fox logo"
                />
              </LogoCell>
              <LogoCell solid>
                <img
                  width="70%"
                  style={{ transform: 'scale(.8)' }}
                  src={gatorade}
                  alt="Gatorade logo"
                />
              </LogoCell>
              <LogoCell solid>
                <img
                  width="70%"
                  style={{ transform: 'scale(.8)' }}
                  src={hamptonInn}
                  alt="Hampton inn logo"
                />
              </LogoCell>
              <LogoCell solid>
                <img
                  width="75%"
                  style={{ transform: 'scale(.8)' }}
                  src={hotPockets}
                  alt="Hot Pockets logo"
                />
              </LogoCell>
              <LogoCell solid>
                <img
                  width="75%"
                  style={{ transform: 'scale(.8)' }}
                  src={kraftFoodsLogo}
                  alt="Kraft Foods logo"
                />
              </LogoCell>
              <LogoCell solid>
                <img
                  width="75%"
                  style={{ transform: 'scale(.8)' }}
                  src={motiv}
                  alt="Motiv logo"
                />
              </LogoCell>
              <LogoCell solid>
                <img
                  width="75%"
                  style={{ transform: 'scale(.8)' }}
                  src={msnbc}
                  alt="MSNBC logo"
                />
              </LogoCell>
              <LogoCell solid>
                <img
                  width="65%"
                  style={{ transform: 'scale(.8)' }}
                  src={nestea}
                  alt="Nestea logo"
                />
              </LogoCell>
              <LogoCell solid>
                <img
                  width="70%"
                  style={{ transform: 'scale(.8)' }}
                  src={paramount}
                  alt="Paramount logo"
                />
              </LogoCell>
              <LogoCell solid>
                <img
                  width="70%"
                  style={{ transform: 'scale(.8)' }}
                  src={pressBros}
                  alt="Press Bros logo"
                />
              </LogoCell>
              <LogoCell solid>
                <img
                  width="75%"
                  style={{ transform: 'scale(.8)' }}
                  src={presspops}
                  alt="Presspops logo"
                />
              </LogoCell>
              <LogoCell solid>
                <img
                  width="75%"
                  style={{ transform: 'scale(.8)' }}
                  src={princessCruises}
                  alt="Princess Cruises logo"
                />
              </LogoCell>
              <LogoCell solid>
                <img
                  width="75%"
                  style={{ transform: 'scale(.8)' }}
                  src={sapphireVentures}
                  alt="Sapphire Ventures logo"
                />
              </LogoCell>
              <LogoCell solid>
                <img
                  width="60%"
                  style={{ transform: 'scale(.8)' }}
                  src={smokeyBones}
                  alt="Smokey Bones logo"
                />
              </LogoCell>
              <LogoCell solid>
                <img
                  width="75%"
                  style={{ transform: 'scale(.8)' }}
                  src={sothebys}
                  alt="Sothebys logo"
                />
              </LogoCell>
              <LogoCell solid>
                <img
                  width="40%"
                  style={{ transform: 'scale(.8)' }}
                  src={tennisChannel}
                  alt="Tennis Channel logo"
                />
              </LogoCell>
              <LogoCell solid>
                <img
                  width="45%"
                  style={{ transform: 'scale(.8)' }}
                  src={toyotaLogo}
                  alt="Toyota logo"
                />
              </LogoCell>
              <LogoCell solid>
                <img
                  width="70%"
                  style={{ transform: 'scale(.8)' }}
                  src={universal}
                  alt="universal logo"
                />
              </LogoCell>
              <LogoCell solid>
                <img
                  width="72%"
                  style={{ transform: 'scale(.8)' }}
                  src={voskos}
                  alt="Voskos logo"
                />
              </LogoCell>
              <LogoCell solid>
                <img
                  width="72%"
                  style={{ transform: 'scale(.8)' }}
                  src={wHotel}
                  alt="w-hotel logo"
                />
              </LogoCell>
              <LogoCell solid>
                <img
                  width="75%"
                  style={{ transform: 'scale(.8)' }}
                  src={westfield}
                  alt="Westfield logo"
                />
              </LogoCell>
            </ShowCells>
            <Space y={{ mobile: 80, tabletMd: 160 }} />
            <div
              ref={bottomRef}
              css={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
              }}
            >
              <WideText as={Link} to="/work">
                SEE OUR WORK
              </WideText>
              <Space y={60} />
              <ScrollToLink
                href="#"
                css={{
                  display: 'flex',
                  flexDirection: 'column',
                  alignItems: 'center',
                }}
              >
                <svg
                  css={{ width: rem(36), height: rem(36) }}
                  viewBox="0 0 24 24"
                >
                  <path
                    fill="#fff"
                    d="M7.41,15.41L12,10.83L16.59,15.41L18,14L12,8L6,14L7.41,15.41Z"
                  />
                </svg>
                <Space y={20} />
                <VerticalLine animateToTop={bottomInView} />
              </ScrollToLink>
            </div>
          </Wrapper>
        </ContentAboveFooter>
        <ChallengeUsFooter />
        <HelloFab />
      </Shell>
    </Fragment>
  )
}
